(function () {
  if (window.Shopify && Shopify.designMode) return;

  var EAGER_SECTIONS = 2;
  var LOOKAHEAD_SECTIONS = 2;

  function revealSections(sections, startIndex) {
    for (var i = startIndex; i <= startIndex + LOOKAHEAD_SECTIONS; i += 1) {
      var section = sections[i];
      if (!section) continue;
      if (!section.classList.contains('section-viewport-ready')) {
        section.classList.add('section-viewport-ready');
        section.dispatchEvent(
          new CustomEvent('theme:section:near-viewport', {
            bubbles: true,
            detail: {
              sectionId: section.id || null,
              index: i
            }
          })
        );
      }
    }
  }

  function initViewportSections() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(main.children).filter(function (node) {
      return node.classList && node.classList.contains('shopify-section');
    });

    if (!sections.length) return;

    sections.forEach(function (section, index) {
      section.dataset.viewportIndex = String(index);

      if (index < EAGER_SECTIONS) {
        section.classList.add('section-viewport-ready');
        return;
      }

      section.classList.add('section-viewport-managed');
    });

    revealSections(sections, 0);

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('section-viewport-ready');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = parseInt(entry.target.dataset.viewportIndex || '-1', 10);
          if (index < 0) return;
          revealSections(sections, index);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '125% 0px',
        threshold: 0.01
      }
    );

    sections.forEach(function (section, index) {
      if (index < EAGER_SECTIONS) return;
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewportSections);
  } else {
    initViewportSections();
  }
})();
